import { useState } from 'react';
import { ThemeProvider } from 'styled-components';
import { GlobalStyles } from './common/global';
import theme from './common/theme';
import './index.css';
import AppRoutes from './routes/app-routes';
import { AppContextProvider } from './utils/context';
/**
 * App component.
 *
 * @returns {JSX.Element} The rendered App component.
 */
const App = () => {
  const [pageTitle, setPageTitle] = useState('');
  const [activeSideNav, setActiveSideNav] = useState('');
  const [showSideNav, setShowSideNav] = useState(true);
  const [permissions, setPermissions] = useState({});
  const [isSuper, setIsSuper] = useState(false);
  const [userType, setUserType] = useState(false);
  const [userId, setUserId] = useState(null);
  const [activeChildSideNav, setActiveChildSideNav] = useState('');
  const [currentUser, setCurrentUser] = useState(null);
  const [selectedCurrency, setSelectedCurrency] = useState(null);
  const [currentTheme, setCurrentTheme] = useState(theme);

  const contextValue = {
    pageTitle,
    setPageTitle,
    activeSideNav,
    setActiveSideNav,
    permissions,
    setPermissions,
    activeChildSideNav,
    setActiveChildSideNav,
    userType,
    setUserType,
    userId,
    setUserId,
    setCurrentUser,
    currentUser,
    isSuper,
    setIsSuper,
    selectedCurrency,
    setSelectedCurrency,
    showSideNav,
    setShowSideNav,
    setCurrentTheme,
    currentTheme,
  };

  return (
    <AppContextProvider value={contextValue}>
      <ThemeProvider theme={currentTheme}>
        <GlobalStyles />
        <AppRoutes />
      </ThemeProvider>
    </AppContextProvider>
  );
};
export default App;
